import React from "react";
import { useDispatch, useSelector } from "react-redux";

import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { getOffers, setActiveTab } from "../../../redux/ducks/sentOffers";
import PageTitle from "../../shared/PageTitle";
import TableTabs from "../../shared/TableTabs";
import SortableTable from "../Received/SortableTable";

const useStyles = makeStyles((theme) => ({
  offersContainer: {
    [theme.breakpoints.up("sm")]: {
      margin: "2rem",
    },
  },
  errorDiv: {
    minHeight: "500px",
    marginTop: "0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
}));

const ReceivedOffers = () => {
  const classes = useStyles();

  const headCells = [
    {
      id: "orderTitle",
      numeric: false,
      disablePadding: false,
      label: "Auftrag Titel",
      disableSorting: true,
    },
    {
      id: "receivingCompanyName",
      numeric: false,
      disablePadding: false,
      label: "Empfangende Firma",
    },
    { id: "price", numeric: true, disablePadding: false, label: "Price" },
    {
      id: "deliveryDate",
      numeric: false,
      disablePadding: false,
      label: "Lieferdatum",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: "Gesendet am",
    },
  ];

  const dispatch = useDispatch();
  const company = useSelector((state) => state.auth.company._id);
  const { offers, loading, error, selectedOffers, activeTab } = useSelector(
    (state) => state.sentOffers
  );

  const tabs = [
    { label: "alle", count: offers.all.length },
    { label: "offen", count: offers.open.length },
    { label: "akzeptiert", count: offers.accepted.length },
    { label: "abgelehnt", count: offers.rejected.length },
    //{ label: "archiviert", count: offers.archived.length },
  ];

  React.useEffect(() => {
    dispatch(getOffers(company));
  }, [company, dispatch]);

  React.useEffect(() => {
    return () => {
      dispatch(setActiveTab(0));
    };
  }, [dispatch]);

  return (
    <div>
      <PageTitle text="Gesendete Angebote" />
      <div className={classes.offersContainer}>
        {error ? (
          <div className={classes.errorDiv}>
            <Typography variant="h6">
              {"Etwas ist schief gelaufen."}
              <br />
              {error.message}
            </Typography>
          </div>
        ) : (
          <div>
            <TableTabs
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
            <SortableTable
              headCells={headCells}
              rows={selectedOffers}
              isLoading={loading}
              SentOffers
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReceivedOffers;
